import { Helmet } from "react-helmet";

function AboutPage(){

    return (
        <div className="about-page">
            <Helmet>
                <title>מחשבון משכנתא | אודות </title>
                <meta name="description" content="אודות המחשבון"/>
            </Helmet>

            <div className="about-hero">
                <h1 className="my-text-gradient">אודות משכנתא דאטה</h1>
                <p className="about-hero-subtitle">
                    האפליקציה מספקת סימולציות מונטה קרלו מתקדמות להלוואות ומשכנתאות, ומיועדת הן ללקוחות פרטיים
                    והן לאנשי מקצוע בתחום הפיננסים. באמצעות מודלים סטטיסטיים עדכניים, אנו מספקים תחזיות מדויקות
                    יותר ומתבססים עליהן בעת ביצוע החישובים.
                </p>
            </div>

            <div className="about-section">
                <h3><i className="bi bi-graph-up-arrow"></i> אז מה ייחודי בשיטת מונטה קרלו?</h3>
                <p>
                    כאשר מחשבונים אחרים מצמידים את המדד ללא מודל סטטיסטי, הם מצמידים אותו רק פעם אחת לניחוש
                    שלכם, ועל בסיס הניחוש מחזירים לכם תוצאה אחת אפשרית. אך בפועל גישה זו אינה נכונה, מכיוון
                    שהמדד בפועל יכול להתפתח באלפי מגמות אפשריות ושונות אחת מהשנייה, וכל התפתחות אפשרית שלו
                    תניב תוצאות שונות. לכן, אנחנו מבצעים את אלפי החישובים האפשריים, על מנת לקבל גבולות טובים
                    יותר לתחומי התרחישים האפשריים של העלויות בפועל.
                </p>
                <div className="about-callout">
                    <i className="bi bi-lightbulb"></i>
                    כל התפתחות אפשרית של המדד תניב לכם תוצאות שונות – לכן אנחנו מריצים אלפי תרחישים, לא ניחוש אחד.
                </div>
            </div>

            <div className="about-section">
                <h3><i className="bi bi-diagram-3"></i> איך זה עובד?</h3>
                <ol className="help-steps">
                    <li className="help-step">
                        <span className="numbered-badge">1</span>
                        <span className="help-step-text">
                            מזינים בקלות את פרטי ההלוואות שברשותכם או שאתם שוקלים לקחת – כולל ריביות, סכומים,
                            תקופות והצמדות למדד, ומרכיבים מהן תמהילים: שילובים שונים של הלוואות המרכיבים יחד
                            את המשכנתא שלכם.
                        </span>
                    </li>
                    <li className="help-step">
                        <span className="numbered-badge">2</span>
                        <span className="help-step-text">
                            האפליקציה מפעילה סימולציית מונטה קרלו: אלפי תרחישים עתידיים של התפתחות המדדים (כגון
                            מדד המחירים לצרכן), בהתבסס על מודלים סטטיסטיים שחוזים את ההתנהגות האפשרית שלהם
                            לאורך זמן.
                        </span>
                    </li>
                    <li className="help-step">
                        <span className="numbered-badge">3</span>
                        <span className="help-step-text">
                            לכל תרחיש מחושבת התוצאה האפשרית – ההחזר החודשי, סך ההחזר הכולל, גובה הקרן והריבית
                            ועוד. כך נבנית תמונה מלאה של טווח האפשרויות, ולא רק "תוצאה אחת" שמבוססת על ניחוש.
                        </span>
                    </li>
                </ol>
            </div>

            <div className="about-section">
                <h3><i className="bi bi-clipboard-data"></i> מה תקבלו בסוף</h3>
                <div className="about-features">
                    <div className="about-feature">
                        <i className="bi bi-bar-chart-line"></i>
                        <h5>גבולות אי-ודאות</h5>
                        <p>גרפים המציגים את ההחזר המינימלי, המקסימלי וטווח האפשרויות המלא</p>
                    </div>
                    <div className="about-feature">
                        <i className="bi bi-layers"></i>
                        <h5>השוואת תמהילים</h5>
                        <p>ניתוחים השוואתיים בין מסלולי המשכנתא השונים שהזנתם</p>
                    </div>
                    <div className="about-feature">
                        <i className="bi bi-stars"></i>
                        <h5>הסבר AI</h5>
                        <p>הסבר מילולי מבוסס בינה מלאכותית, שמסכם את המידע ומדגיש את היתרונות והחסרונות של כל תמהיל</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AboutPage;
